// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".msdsc {\n  margin-top: 10px;\n}\n.pmsds > .cardheader {\n  padding-top: 0px !important;\n  padding-bottom: 10px !important;\n}\n.example-item .q-checkbox .q-checkbox__inner {\n  margin: auto !important;\n}\n.example-item .inline {\n  display: block !important;\n}\n.noselectImg {\n  opacity: 0.2;\n}", ""]);
// Exports
module.exports = exports;
